module.exports = __webpack_public_path__ + "static/way_ahead-6128e8bda9fc196bc9e0ef340c9907f4.png";